// @flow
import React from 'react';
import i18n from 'app/common/lib/i18n';
import ProductGroupsList from 'app/common/react/components/profile/ProductGroups/ProductGroupsList';
import SectionHeader from 'app/common/react/components/profile/SectionHeader/SectionHeader';
import TimeSpent from 'app/common/lib/react/TimeSpent';
import { Box } from 'gestalt';

type Props = {|
  isOwnProfile: boolean,
  productGroups: Array<Object>,
  scrollContainer?: () => HTMLElement,
  username: string,
|};

const MIN_WIDTH = 996;

export default function ProfileProductGroups({
  isOwnProfile,
  productGroups,
  username,
  scrollContainer,
}: Props) {
  const timeSpentViewParam = isOwnProfile
    ? PCONST.thrift.ViewParameterType.USER_SELF
    : PCONST.thrift.ViewParameterType.USER_OTHERS;

  return (
    <Box>
      <Box justifyContent="center" display="flex" marginLeft={4} marginBottom={2}>
        <SectionHeader label={i18n._('Featured', 'featured product groups')} />
      </Box>
      <TimeSpent
        view={PCONST.thrift.ViewType.USER}
        viewParameter={timeSpentViewParam}
        component={PCONST.thrift.ComponentType.USER_STOREFRONT}
      >
        <Box justifyContent="between" display="flex">
          <Box minWidth={MIN_WIDTH} width="100%">
            <ProductGroupsList
              productGroups={productGroups}
              isOwnProfile={isOwnProfile}
              username={username}
              scrollContainer={scrollContainer}
            />
          </Box>
        </Box>
      </TimeSpent>
    </Box>
  );
}
